// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container-SKTxw {
  padding: 0px 32px 20px;
}

.home-toolbar-oCljj {
  min-width: 800px;
  height: 56px;
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: space-between;
}

.home-title_container-MmsFT {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
}

.home-title_title-VTz62 {
  font-size: 17px;
}

.home-title_icon-HnE9M {
  --size: 20px;
}

.home-content-aPL_H {
  margin-top: 0px;
}

.home-tableHeader_container-xfEGk {
  height: 48px;
}

.home-tableHeader_cellContent-Hpt5C {
  font-size: 14px;
  color: var(--color-neutral-800);
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".container {\n  padding: 0px 32px 20px;\n}\n\n.toolbar {\n  min-width: 800px;\n  height: 56px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title_container {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.title_title {\n  font-size: 17px;\n}\n\n.title_icon {\n  --size: 20px;\n}\n\n.content {\n  margin-top: 0px;\n}\n\n.tableHeader_container {\n  height: 48px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `home-container-SKTxw`,
	"toolbar": `home-toolbar-oCljj`,
	"title_container": `home-title_container-MmsFT`,
	"title_title": `home-title_title-VTz62`,
	"title_icon": `home-title_icon-HnE9M`,
	"content": `home-content-aPL_H`,
	"tableHeader_container": `home-tableHeader_container-xfEGk`,
	"tableHeader_cellContent": `home-tableHeader_cellContent-Hpt5C`
};
export default ___CSS_LOADER_EXPORT___;
